<aside
  class="menu-panel fixed inset-0 z-50 flex h-full w-full flex-col justify-between bg-secondary transition-transform duration-300 ease-in-out px-4 pb-7"
  [class.translate-y-0]="visible"
  [class.translate-y-full]="!visible"
>
  <div class="flex flex-col justify-center gap-y-4">
    <div class="grid place-items-center">
      <img ngSrc="/svg/logo.svg" priority alt="Op Goeie Grond" height="92.5" width="110">
    </div>
    <nav class="flex flex-col overflow-y-auto px-2 text-white font-secondary font-medium">
      <a [routerLink]="['/']" (click)="close()" class="flex items-center gap-x-3 border-t border-secondary-300 py-4">
        <ng-icon name="heroHome" size="1.5rem" strokeWidth="1"></ng-icon>
        Home
      </a>
      <a [routerLink]="['/kaart']" (click)="close()"
         class="flex items-center gap-x-3 border-t border-secondary-300 py-4">
        <ng-icon name="heroMap" size="1.5rem" strokeWidth="1"></ng-icon>
        Kaart
      </a>
      <a [routerLink]="['/locaties']" (click)="close()"
         class="flex items-center gap-x-3 border-t border-secondary-300 py-4">
        <ng-icon name="heroListBullet" size="1.5rem" strokeWidth="1"></ng-icon>
        Locaties
      </a>
      <a [routerLink]="['/routes']" (click)="close()"
         class="flex items-center gap-x-3 border-t border-secondary-300 py-4">
        <ng-icon name="tablerRoute" size="1.5rem" strokeWidth="1"></ng-icon>
        Routes
      </a>
      <a [routerLink]="['/evenementen']" (click)="close()"
         class="flex items-center gap-x-3 border-t border-secondary-300 py-4">
        <ng-icon name="heroCalendarDays" size="1.5rem" strokeWidth="1"></ng-icon>
        Evenementen
      </a>
      <a [routerLink]="['/gouden-tips']" (click)="close()"
         class="flex items-center gap-x-3 border-t border-secondary-300 py-4">
        <ng-icon name="heroStar" size="1.5rem" strokeWidth="1"></ng-icon>
        Gouden tips
      </a>
      <a [routerLink]="['/settings']" (click)="close()"
         class="flex items-center gap-x-3 border-y border-secondary-300 py-4">
        <ng-icon name="heroCog6Tooth" size="1.5rem" strokeWidth="1"></ng-icon>
        Instellingen
      </a>
    </nav>
  </div>

  <div class="flex justify-center">
    <button type="button" (click)="close()" aria-label="Menu sluiten"
            class="text-white flex flex-col gap-2 items-center">
      <ng-icon name="heroXMark" size="2.5rem" strokeWidth="1.5"></ng-icon>
      <span class="font-secondary font-medium">
        Sluiten
      </span>
    </button>
  </div>
</aside>
